import { NegarContrato } from "./metodos/NegarContrato";
import { ObterResumoOrcamento } from "./metodos/ObterResumoOrcamento";
import { ObterURLDoContrato } from "./metodos/ObterURLDoContrato";
import { ValidarContrato } from "./metodos/ValidarContrato";
import { VerificarSolicitacaoRespondida } from "./metodos/VerificarSolicitacaoRespondida";

export const AssinaturaDigitalService = {
  ObterResumoOrcamento,
  ObterURLDoContrato,
  ValidarContrato,
  NegarContrato,
  VerificarSolicitacaoRespondida,
};